<template>
  <div class="market-cap-recommendations">
    <div class="header">Marketcap wise Recommendations</div>
    <div class="scroll-wrapper">
      <!-- Show skeleton while loading -->
      <div v-if="isRecoListLoading">
        <el-row class="scroll-container" :gutter="20">
          <el-col :span="6" v-for="(item, index) in 3" :key="index">
            <el-card class="recommendation-card" :body-style="{ padding: '10px' }">
              <el-skeleton :rows="3" animated />
            </el-card>
          </el-col>
        </el-row>
      </div>
      <!-- Show recommendations after loading -->
      <div v-else-if="marketCapRecommendations.length" class="scroll-container">
        <div v-for="(recommendation, index) in marketCapRecommendations" :key="index" class="recommendation-card" :style="{ backgroundColor: recommendation.bgColor }" @click="applyFilter(recommendation)">
          <div class="card-header">
            <div class="cap-name">{{ recommendation.cap_name }}</div>
            <img :src="getSymbolPath(recommendation.cap_name)" alt="symbol" class="symbol-image" />
          </div>
          <div class="card-body">
            <div :style="{ color: getCapColor(recommendation.cap_name) }">
              <span class="recommendation-count">{{ recommendation.count }}</span>
              <br />
              <span class="recommendation-text">Recommendations</span>
            </div>
            <div class="arrow">
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- No Data Available Component -->
      <NoDataFound v-else />
    </div>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import NoDataFound from '@/components/NoDataFound.vue';

export default {
  name: 'MarketCapRecommendations',
  props: ['marketCapRecommendations', 'isRecoListLoading'],

  components: {
    NoDataFound,
  },
  data() {
    return {
      // marketCapRecommendations: [], // Stores market cap data with count
      // isRecoListLoading: true, // Loading state
    };
  },
  mounted() {
    // this.getMarketCapWiseRecommendation();
  },
  methods: {
    applyFilter(cap) {
      this.$router.push(`/experts-past-recommendations?cap=${cap.cap_name}`);
    },

    getCapColor(cap_name) {
      // Return text color based on cap name
      switch (cap_name) {
        case 'Mid Cap':
          return '#766800';
        case 'Small Cap':
          return '#2D2E8D';
        case 'Large Cap':
          return '#009380';
        default:
          return '#000000';
      }
    },
    
    getSymbolPath(cap_name) {
      // Return path to symbol image based on cap name
      switch (cap_name) {
        case 'Mid Cap':
          return require('@/assets/images/MC.svg');
        case 'Small Cap':
          return require('@/assets/images/SC.svg');
        case 'Large Cap':
          return require('@/assets/images/LC.svg');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.market-cap-recommendations {
  // padding: 0 10px;

  .header {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 10px;
    color: #333;
  }

  .scroll-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;

    /* Hide scrollbar while keeping scrolling functionality */
    &::-webkit-scrollbar {
      display: none;
    }

    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .scroll-container {
    display: flex;
    flex-wrap: nowrap;
    gap: 15px;
    padding-bottom: 10px;
    width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .recommendation-card {
    flex: 1; // Make each card take equal width
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 15px;
    white-space: normal;
    cursor: pointer;

    &[data-cap="Small Cap"] {
    order: 1;
  }
  &[data-cap="Mid Cap"] {
    order: 2;
  }
  &[data-cap="Large Cap"] {
    order: 3;
  }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .cap-name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }

      .symbol-image {
        width: 48px;
        height: 48px;
      }
    }

    .card-body {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;

      .recommendation-count {
        font-size: 18px;
        font-weight: 700;
      }

      .recommendation-text {
        font-size: 15px;
        font-weight: 500;
      }

      .arrow {
        i {
          font-size: 16px;
        }
      }
    }
  }

  // Responsive styles for mobile and tablet
  @media (max-width: 768px) {
    .scroll-container {
      gap: 10px;
      width: max-content;
    }

    .recommendation-card {
      flex: 1 1 calc(50% - 10px); // Cards take 50% of container width minus gap

      .card-header {
        .cap-name {
          font-size: 15px;
          font-weight: 600;
        }

        .symbol-image {
          width: 40px;
          height: 40px;
        }
      }
      .card-body {
        .recommendation-count {
          font-size: 15px;
          font-weight: 700;
        }

        .recommendation-text {
          font-size: 12px;
          font-weight: 500;
        }

        .arrow {
          i {
            font-size: 16px;
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .scroll-container {
      gap: 8px;
      width: max-content;
    }

    .recommendation-card {
      // flex: 1 1 calc(100% - 10px);
    }
  }
}
</style>
